import { render, staticRenderFns } from "./BankStatementPagination.vue?vue&type=template&id=6f0e5d0c&"
import script from "./BankStatementPagination.vue?vue&type=script&lang=js&"
export * from "./BankStatementPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports